// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"4459d62e","139":"0bf27a7b","167":"e195bd8e","215":"9c9d2aa9","239":"0450d4f6","272":"db71e462","420":"70bfa20c","480":"e3f5d423","499":"b84e4318","593":"5dba7079","661":"e0ecf369","769":"0cb313ca","853":"b47e11eb","951":"cc59301d"}[chunkId] + ".chunk.js";
};